<div class="container">
  <div class="header">
    <pdq-heading element="h3">Manage processing time</pdq-heading>
    <pdq-button
      [disabled]="isLoading$ | async"
      (onClick)="dialogRef.close()"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">
      <form [formGroup]="processTimeFormGroup" (submit)="onSave()">
        <div class="errors">
          @if (processTimeFormGroup.controls?.processingTime?.hasError('min') && submitted) {
            <span>* Please add at least 1 day</span>
          }
          @if (processTimeFormGroup.controls?.processingTime?.hasError('required') && submitted) {
            <span>* Required to select days</span>
          }
          @if (processTimeFormGroup.controls?.processingTimeShippingIds?.hasError('missingIds') && submitted) {
            <span>* {{ processTimeFormGroup.controls?.processingTimeShippingIds?.errors?.missingIds }}</span>
          }
        </div>

        <div class="upper-inputs">
          <pdq-input-arrows
            label="Add"
            [min]="0"
            [formControl]="processTimeFormGroup.controls['processingTime']"
            [invalid]="
              !processTimeFormGroup.controls['processingTime'].valid &&
              processTimeFormGroup.controls['processingTime'].dirty
            "></pdq-input-arrows>
          <pdq-dropdown
            [options]="processTimeTypeOptions"
            [defaultOption]="processTimeTypeOptions[0]"
            [formControl]="processTimeFormGroup.controls['processingTimeType']"></pdq-dropdown>
        </div>

        <div class="content__list">
          For the following methods:

          <div>
            <pdq-checkbox
              label="Check all methods"
              [variant]="
                processTimeFormGroup.controls['processingTimeShippingIds']?.value?.length
                  | processingCheckAll: data?.shippings
              "
              [checked]="processTimeFormGroup.controls['processingTimeShippingIds']?.value?.length"
              (onChange)="onCheckAll($event)"></pdq-checkbox>
          </div>

          <div class="shippings-wrapper">
            <div class="shippings">
              @for (mappedShipping of data?.shippings | processingTimeOptions; track mappedShipping) {
                <pdq-checkbox
                  [checked]="
                    processTimeFormGroup.controls['processingTimeShippingIds']?.value?.includes(mappedShipping.id)
                  "
                  [icon]="mappedShipping.disabled ? 'more_information' : null"
                  [description]="mappedShipping.disabled ? 'Local method not supported yet' : ''"
                  [label]="mappedShipping.name"
                  [disabled]="mappedShipping.disabled"
                  (onChange)="onCheckedShipping($event, mappedShipping)"></pdq-checkbox>
              }
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <footer>
    <pdq-button [disabled]="isLoading$ | async" label="Cancel" (onClick)="dialogRef.close()"></pdq-button>
    <pdq-button (onClick)="onSave()" [loading]="isLoading$ | async" variant="primary" label="Save"></pdq-button>
  </footer>
</div>
